import { Controller } from "@hotwired/stimulus";

// Auto-submits the magic-link confirm form on the GET /auth/connect page
// (app/views/connect/registrations/verify.html.erb) so redeeming the link is
// one tap (SUR-2174). The single-use token is consumed only by this POST —
// email scanners / link prefetch issue GETs and don't run JS, so they never
// reach this submit and never burn the token. The visible button is the no-JS
// fallback.
export default class extends Controller {
  static targets = ["form"];

  connect() {
    if (this.hasFormTarget) {
      // Defer a tick so the page paints the "Confirming…" state first.
      requestAnimationFrame(() => this.formTarget.requestSubmit());
    }
  }
}
